import { render } from "./TextCurrencyInput.vue?vue&type=template&id=5b2b4328&bindings={\"modelCents\":\"props\",\"name\":\"setup\",\"label\":\"setup\",\"placeholder\":\"setup\",\"usdStr\":\"setup\",\"changeValue\":\"setup\"}"
import script from "./TextCurrencyInput.vue?vue&type=script&lang=js"
export * from "./TextCurrencyInput.vue?vue&type=script&lang=js"
script.render = render

export default script